import React, { useState, useContext } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogTitle, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styles from './QAReturnToMobileAppButton.styles';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import cn from 'classnames';

// SERVICES
import { getZippedImages, unstashOrder } from '../../services';
import { OrderReviewContext } from '../QaOrderReview/OrderReviewContext';
import { AppContext } from '../../AppContext';
import { useHistory } from 'react-router';

const QAReturnToMobileAppButton = ({ classes, onClose }) => {
  const [showSendBackToAppDialog, setShowSendBackToAppDialog] = useState(false);
  const [unstashLoading, setUnstashLoading] = useState(false);

  const history = useHistory();

  const { dispatch: appDispatch } = useContext(AppContext);
  const {
    state: { orderLineId },
  } = useContext(OrderReviewContext);

  const handleDialogOpen = () => {
    setShowSendBackToAppDialog(true);
  };

  const handleDialogClose = () => {
    setShowSendBackToAppDialog(false);

    !!onClose && onClose();
  };

  const returnToDashboard = () => {
    // toggleSidebar(true);
    return history.push('/'); // this is the homepage (and orders grid) for inspectors
  };

  const sendOrderBackToApp = async () => {
    try {
      setUnstashLoading(true);
      await unstashOrder(orderLineId);

      returnToDashboard();
    } catch (error) {
      //
      console.log('UNSTASH failed... check log for details');
    }
    setUnstashLoading(false);
  };

  return (
    <React.Fragment>
      <MenuItem onClick={handleDialogOpen}>Return to App</MenuItem>

      {/* Dialog for confirming an order will be sent back to the mobile app */}
      <Dialog open={showSendBackToAppDialog} onClose={handleDialogClose} aria-labelledby="form-dialog-title">
        <DialogTitle style={{ textAlign: 'center' }}>
          Are you sure you want to send this order back to your mobile app?
        </DialogTitle>

        <DialogActions
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <Button onClick={handleDialogClose} variant="contained" color="secondary" style={{ color: 'white' }}>
            No
          </Button>

          <div style={{ width: 24 }} />

          <Button
            onClick={sendOrderBackToApp}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white' }}
            disabled={unstashLoading}
          >
            {unstashLoading ? (
              <CircularProgress style={{ fill: '#222', color: 'white' }} size={24} />
            ) : (
              <span>Yes</span>
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

QAReturnToMobileAppButton.defaultProps = {};
QAReturnToMobileAppButton.propTypes = {};

export default withStyles(styles)(QAReturnToMobileAppButton);
